import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";
import cs from "classnames";
import NewLogo from "../../assets/icons/Academiq-logo.svg";
import NavbarItemList from "./NavbarItemList";
import { ReactComponent as MenuLogo } from "../../assets/icons/poweredJUSTWIN.svg";
import { RootState } from "../../store/store";
import useDetectOutsideClick from "../../hooks/useOutsideDetectClick";
import ProfileItem from "./ProfileItem";
import config from "../../../package.json";
import LogOutIco from "../../assets/icons/logout2.svg";
import { signOut } from "../../store/actions/auth";
import { useDispatch } from "react-redux";
import Notifications from "./Notifications";
import Messages from "./Messages";
import jwtDecode from "jwt-decode";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import Chats from "./Chats";
import LanguageSwitcher from "./LanguageSwitcher";

const Navbar: React.FC = () => {
  const { t } = useTranslation();
  const { isAuth } = useSelector((state: RootState) => state.auth);
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const [isExpanded, setIsExpanded] = useState(false);
  const navbarRef = useRef<HTMLDivElement | null>(null);
  const { auth, currentUser } = useSelector((state: RootState) => state);
  const [isMessagesOpen, toggleMessagesOpen] = useState(false);
  const [isNotificationOpen, toggleNotificationOpen] = useState(false);
  const permission = useSelector((state: any) => state.permissions.permissions);

  const handleMenuExpand = (value: boolean) => {
    setIsExpanded(value);
  };
  const { push } = useHistory();
  const handleSignOut = async () => {
    await dispatch(signOut());
    push("/login");
  };

  useEffect(() => {
    handleMenuExpand(false);
  }, [pathname]);

  useDetectOutsideClick(navbarRef, () => handleMenuExpand(false));

  const containerClassNames = cs(
    "flex flex-row-reverse /* justify-between */ md:flex-col md:sticky top-0 md:h-screen py-8 px-8 md:pb-0 relative z-40",
    {
      "bg-white md:bg-transparent opacity-100": isExpanded,
    },
  );

  const [height, setHeight] = useState(0);

  useEffect(() => {
    const observer = new ResizeObserver(() => {
      if (navbarRef.current) {
        const rect = navbarRef.current.getBoundingClientRect();
        setHeight(rect.height);
      }
    });

    if (navbarRef.current) {
      observer.observe(navbarRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const isChatHasPermission =
    permission[0]?.Id === -1
      ? true
      : !!permission.find((permission: any) => permission.Id === 215);

  const isOverflowActive = height < 824;

  return (
    <nav
      className={containerClassNames}
      ref={navbarRef}
      style={{
        background: "transparent",
        position:'fixed',
        width:'225px'
      }}
    >
      {isAuth &&
      localStorage.getItem("token") &&
      // @ts-ignore
      jwtDecode(localStorage.getItem("token"))?.IsTemporaryPasswordChanged ===
        "True" ? (
        <>
          <div className="flex md:w-full md:flex-col h-full md:py-12">
            {/* <MenuButton
            isExpanded={isExpanded}
            handleMenuExpand={handleMenuExpand}
          /> */}
            <div style={{ width: "100%", padding: "0px 18px 20px 18px" }}>
              <div
                style={{
                  paddingLeft: "25px",
                }}
              >
                <img
                  src={NewLogo}
                  alt="logo"
                  style={{ width: "120.5px", height: "25.8px" }}
                />
              </div>
            </div>
            {/* <IconsBox>
            <SvgBox>
              <Chats />
            </SvgBox>
            <SvgBox style={{ marginLeft: "0px" }}>
              <Notifications />
            </SvgBox>
          </IconsBox> */}
            <NavbarItemList
              isExpanded={isExpanded}
              isNavbarOverflowActive={isOverflowActive}
              height={height !== undefined ? height : 0}
            />
            <>
              <IconsBox>
                <Chats />
                <Notifications />
              </IconsBox>
            </>
          </div>
        </>
      ) : (
        <div className="flex flex-col md:pt-36 text-lightpurple text-sm opacity-70 leading-relaxed"></div>
      )}
      {/* <Logo className="h-32 md:h-32 md:mx-auto" /> */}

      <div
        className="hidden md:flex justify-between px-12  pb-8 text-xxs"
        style={{
          flexDirection: "column",
          color: "#909090",
          textAlign: "center",
          paddingBottom: "23px",
        }}
      >
        {/* {auth.isAuth && currentUser && ( */}
        {auth.isAuth && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: "0px",
              fontSize: "13px",
              marginBottom: "15px",
            }}
          >
            <LanguageSwitcher />
            <div
              onClick={handleSignOut}
              style={{
                cursor: "pointer",
                display: "flex",
                gap: "3px",
                justifyContent: "center",
                alignItems: "center",
                height: "25px",
              }}
            >
              <img src={LogOutIco} alt="logout icon" />
              <p
                style={{
                  color: "#9cb0c4",
                }}
              >
                {t("common.logout")}
              </p>
            </div>
          </div>
        )}

        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <MenuLogo
            style={{
              maxWidth: "auto",
              // height: 'auto',
              // display: 'block',
              // margin: '0 auto',
            }}
          />
        </div>
        {/* <span className="opacity-50" style={{}}>
          MMlab2023
        </span> */}
        {/* <span>wersja {config.version}</span> */}
      </div>
    </nav>
  );
};

export default Navbar;

export const SvgBox = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  cursor: pointer;
  gap: 11px;
  margin-top: auto;
  padding-bottom: 12px;

  & > p {
    font-size: 14px;
    font-weight: 400;
    color: white;
    text-transform: uppercase;
  }
`;

const IconsBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;

  // padding-bottom: 20px;
  width: 100%;

  /* background: red; */
`;
